import { WarehouseStatus } from "../DashboardPage/types";

export const SET_DASHBOARD_LOADING = "SET_DASHBOARD_LOADING";
export const SET_DASHBOARD = "SET_DASHBOARD";

export interface DashboardState {
  data: WarehouseStatus[];
  loading: boolean;
}

const defaultState: DashboardState = {
  data: [],
  loading: true,
};

function dashboardReducer(
  state = defaultState,
  action: { type: string; payload: any }
): DashboardState {
  switch (action.type) {
    case SET_DASHBOARD:
      return { ...state, data: action.payload, loading: false };
    case SET_DASHBOARD_LOADING:
      return { ...state, loading: true };
    default:
      return state;
  }
}
export default dashboardReducer;
